import { Skeleton, Spin } from 'antd';
import clsx from 'clsx';
import Sidebar from '../../components/Core/Sidebar';

interface LoadingOverlayProps {
  label: string;
  isVisible: boolean;
}

const LoadingOverlay = ({ label, isVisible }: LoadingOverlayProps) => {
  return (
    <div
      className={clsx(
        'absolute inset-0 z-[9999] flex items-center justify-center',
        'bg-background/80',
        'backdrop-blur-none transition-[backdrop-filter,opacity] duration-200 ease-in-out',
        isVisible
          ? 'pointer-events-auto opacity-100 backdrop-blur-sm'
          : 'pointer-events-none opacity-0 backdrop-blur-none'
      )}
    >
      <div className="flex h-full w-full overflow-hidden">
        <header className="fixed left-0 right-0 top-0 z-40 h-14 w-[100vw] bg-gray-medium" />
        <Sidebar>
          <div className="flex w-full flex-1 flex-col items-center justify-center gap-4 px-3">
            <Skeleton.Input active block />
            <Skeleton.Input active size="small" block />
            <Skeleton.Input active size="small" block />
            <Skeleton.Input active size="small" block />
            <Skeleton.Input active size="small" block />
            <Skeleton.Input active size="small" block />
          </div>
        </Sidebar>

        <div className="ml-[60px] flex h-full w-full flex-col items-center justify-center gap-2 rounded-md p-4 lg:ml-[205px]">
          <div className="flex h-36 w-full bg-background"></div>
          <div className="flex h-full w-full flex-col items-center justify-center rounded-md bg-white">
            <Spin />
            <span className="ml-2 text-sm font-medium text-blue-dark">
              {label}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
